// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bqBGP","col":"styles_col__1Btcz"};